import ColumnAdder from "./ColumnAdder";

export default function ColumnAdderRight({
  figurePanelId,
  tableOutlineShowing,
  rows,
  cols,
}){
  return (

    <div class="sg-col" style={{
          //paddingLeft:20,
          alignItems:'start',
          justifyContent:'center',
          display:(tableOutlineShowing?undefined:'hidden')
        }}>

          {tableOutlineShowing && <ColumnAdder {...{
            rows,
            columnIndex:cols,
            figurePanelId
          }}/> }
        </div>
  )

}
